import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';
type TranslationResource = typeof import('../public/locales/en/translation.json');

export const defaultNS = 'translation';
export const resources = {
  en: {
    // Runtime translations are fetched via i18next-http-backend from /locales/**.
    // Keep the JSON type only for i18next key inference.
    translation: {} as TranslationResource,
  },
} as const;

/** Resolves once i18next has initialised and loaded the default namespace. */
export const i18nReady = i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    compatibilityJSON: 'v4',
    supportedLngs: ['en'],
    fallbackLng: 'en',
    ns: [defaultNS],
    defaultNS,
    react: {
      useSuspense: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

export default i18n;
